(() => {
  const COMPONENT_SELECTOR = '[data-vael-concierge]';

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => {
      return !element.hasAttribute('hidden') && element.offsetParent !== null;
    });
  }

  function initialiseConcierge(component) {
    if (!component || component.dataset.vaelInitialised === 'true') return;

    const openButton = component.querySelector('[data-vael-concierge-open]');
    const modal = component.querySelector('[data-vael-concierge-modal]');
    const closeButton = component.querySelector('[data-vael-concierge-close]');

    if (!openButton || !modal || !closeButton) return;

    component.dataset.vaelInitialised = 'true';

    let previousActiveElement = null;
    let savedScrollY = 0;

    function openModal() {
      previousActiveElement = document.activeElement;
      savedScrollY = window.scrollY || window.pageYOffset;

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');

      document.body.classList.add('vael-concierge-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';

      requestAnimationFrame(() => {
        modal.classList.add('is-open');
        closeButton.focus();
      });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');

      window.setTimeout(() => {
        modal.hidden = true;

        document.body.classList.remove('vael-concierge-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';

        window.scrollTo(0, savedScrollY);

        if (
          previousActiveElement &&
          typeof previousActiveElement.focus === 'function'
        ) {
          previousActiveElement.focus();
        } else {
          openButton.focus();
        }
      }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220);
    }

    function handleKeydown(event) {
      if (!modal.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = getFocusableElements(modal);

      if (focusable.length === 0) {
        event.preventDefault();
        closeButton.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    openButton.addEventListener('click', (event) => {
      event.preventDefault();
      openModal();
    });
    modal.addEventListener('keydown', handleKeydown);

    // Clicking anywhere inside the modal (backdrop, content, or the close
    // button) dismisses it. Links (like the mailto button) still work first.
    modal.addEventListener('click', (event) => {
      if (event.target.closest('a')) return;
      closeModal();
    });
  }

  function initialiseAll(root = document) {
    if (root.matches && root.matches(COMPONENT_SELECTOR)) {
      initialiseConcierge(root);
    }

    root.querySelectorAll?.(COMPONENT_SELECTOR).forEach(initialiseConcierge);
  }

  initialiseAll();

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAll(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    initialiseAll();
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          initialiseAll(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
